import styled from 'styled-components';
import { THEME } from '../../../themes';

export const HorizontalDividerContainer = styled.div`
  height: 1px;
  background-color: ${THEME.COLORS_RGB.PRIMARY_DIVIDER};
`;
